import { prevent } from "../../../utils"

// Payment Card Component
export class PaymentCard {
    constructor({
        name,
        subtitle = '',
        imagePath,
        isSelected = false,
        isVertical = false,
        onClick = () => { },
        onRemove = null,
        personalizedContent = '',
        variant = 'default',
    }) {
        this.name = name;
        this.subtitle = subtitle;
        this.imagePath = imagePath;
        this.isSelected = isSelected;
        this.isVertical = isVertical;
        this.onClick = onClick;
        this.onRemove = onRemove;
        this.personalizedContent = personalizedContent;
        this.variant = variant;
        this.element = this.createElement();
        this.attachEventListeners();
    }

    createElement() {
        const card = document.createElement('div');

        const variants = {
            default: 'border-gray-100',
            blue: 'border-blue-500 bg-blue-transparent text-blue-500'
        };

        // Get the variant class or use default if the specified variant doesn't exist
        const variantClass = variants[this.variant] || variants['default'];

        if (this.isVertical) {
            // Vertical layout
            card.className = `${variantClass} bg-white border-1 flex-center flex gap-12 relative rounded-lg shadow-sm smoth-transition ${this.isSelected ? 'border-green-500 bg-selected-green' : ''}`;
            card.style.cssText = 'padding: 10px 12px; min-height: 56px;';

            const isSVG = this.imagePath.includes('<svg')
            card.innerHTML = `
              <div style="width:40px;height:40px;min-width:40px;border-radius:8px;background:#eef2ff;display:flex;align-items:center;justify-content:center;overflow:hidden;">
                ${isSVG ? this.imagePath : `<img style="width:26px;height:26px;object-fit:contain;" src="${this.imagePath}" alt="${this.name}">`}
              </div>
              <div style="flex:1;min-width:0;">
                <div class="font-14 font-500 overflow-hidden text-elipsis w-100" style="line-height:1.3;">${this.name}</div>
                ${this.subtitle ? `<p class="payment-card-subtitle overflow-hidden text-elipsis w-100" style="font-size:12px;color:#64748b;margin:2px 0 0;line-height:1.3;">${this.subtitle}</p>` : ''}
              </div>
              <div class="payment-card-personalized-content">${this.personalizedContent}</div>
              <svg class="check-icon ${this.isSelected ? "" : "oculto"}" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" style="flex-shrink:0;">
                <circle cx="9" cy="9" r="9" fill="#97FFCD"></circle>
                <path d="M13.2529 7.06537C13.5824 6.73587 13.5824 6.20163 13.2529 5.87213C12.9234 5.54262 12.3891 5.54262 12.0596 5.87213L7.59375 10.338L5.94037 8.68463C5.61087 8.35512 5.07663 8.35512 4.74713 8.68463C4.41762 9.01413 4.41762 9.54837 4.74713 9.87787L6.99713 12.1279C7.32663 12.4574 7.86087 12.4574 8.19037 12.1279L13.2529 7.06537Z" fill="#00D26E"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9ZM1.6875 9C1.6875 4.96142 4.96142 1.6875 9 1.6875C13.0386 1.6875 16.3125 4.96142 16.3125 9C16.3125 13.0386 13.0386 16.3125 9 16.3125C4.96142 16.3125 1.6875 13.0386 1.6875 9Z" fill="#00D26E"></path>
              </svg>
              ${this.onRemove ? `<button type="button" class="payment-card-remove" aria-label="Remover cartão" title="Remover cartão" style="margin-bottom:0;flex-shrink:0;width:34px;height:34px;border:0;border-radius:8px;background:transparent;color:#94a3b8;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background 0.15s,color 0.15s;" onmouseenter="this.style.background='#fef2f2';this.style.color='#dc2626';" onmouseleave="this.style.background='transparent';this.style.color='#94a3b8';"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg></button>` : ''}
            `;
        } else {
            // Horizontal layout (original)
            card.className = `${variantClass} border-1 flex-center flex-column gap-4 p-16 rounded-lg m-w-h-100px max-w-h-100px shadow-sm bg-white smoth-transition relative ${this.isSelected ? 'border-green-500 bg-selected-green' : ''}`;

            const isSVG = this.imagePath.includes('<svg')
            card.innerHTML = `
              ${isSVG ? this.imagePath : `<img class="w-h-30 object-fit-contain" src="${this.imagePath}" alt="${this.name}">`}
              <div class="flex-column flex-center text-center w-100">
                <div class="font-14 font-500 w-100">${this.name}</div>
                ${this.subtitle ? `<p class="overflow-hidden text-elipsis text-gray-300 w-100" style="font-size: 8px;">${this.subtitle}</p>` : ''}
              </div>
              <svg class="check-icon ${this.isSelected ? "" : "oculto"}" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" style="position: absolute;bottom: -10px;">
                <circle cx="9" cy="9" r="9" fill="#97FFCD"></circle>
                <path d="M13.2529 7.06537C13.5824 6.73587 13.5824 6.20163 13.2529 5.87213C12.9234 5.54262 12.3891 5.54262 12.0596 5.87213L7.59375 10.338L5.94037 8.68463C5.61087 8.35512 5.07663 8.35512 4.74713 8.68463C4.41762 9.01413 4.41762 9.54837 4.74713 9.87787L6.99713 12.1279C7.32663 12.4574 7.86087 12.4574 8.19037 12.1279L13.2529 7.06537Z" fill="#00D26E"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9ZM1.6875 9C1.6875 4.96142 4.96142 1.6875 9 1.6875C13.0386 1.6875 16.3125 4.96142 16.3125 9C16.3125 13.0386 13.0386 16.3125 9 16.3125C4.96142 16.3125 1.6875 13.0386 1.6875 9Z" fill="#00D26E"></path>
              </svg>
              ${this.onRemove ? '<button type="button" class="payment-card-remove" aria-label="Remover cartão" title="Remover cartão" style="position:absolute;top:4px;right:4px;width:22px;height:22px;border:0;border-radius:50%;background:#fff;color:#d93025;box-shadow:0 1px 4px rgba(0,0,0,.14);font-size:16px;line-height:20px;cursor:pointer;">×</button>' : ''}
            `;
        }

        return card;
    }

    attachEventListeners() {
        this.element.addEventListener('click', (event) => {
            prevent(event)
            this.onClick();
        });
        const removeButton = this.element.querySelector('.payment-card-remove');
        if (removeButton && this.onRemove) {
            removeButton.addEventListener('click', (event) => {
                prevent(event);
                event.stopPropagation();
                this.onRemove();
            });
        }
    }

    setSelected(selected) {
        this.isSelected = selected;
        this.element.classList.toggle('border-green-500', selected);
        this.element.classList.toggle('bg-selected-green', selected);
        this.element.querySelector('.check-icon').classList.toggle('oculto', !selected);
    }

    setVertical(vertical) {
        if (this.isVertical !== vertical) {
            this.isVertical = vertical;
            // Replace the current element with a newly created one
            const parent = this.element.parentNode;
            if (parent) {
                const newElement = this.createElement();
                this.attachEventListeners();
                parent.replaceChild(newElement, this.element);
                this.element = newElement;
            }
        }
    }

    setVariant(variant) {
        if (this.variant !== variant) {
            this.variant = variant;
            // Replace the current element with a newly created one
            const parent = this.element.parentNode;
            if (parent) {
                const newElement = this.createElement();
                this.attachEventListeners();
                parent.replaceChild(newElement, this.element);
                this.element = newElement;
            }
        }
    }

    setSubtitle(subtitle) {
        this.subtitle = subtitle;
        const subtitleElement = this.element.querySelector('.payment-card-subtitle');
        if (subtitleElement) {
            subtitleElement.textContent = subtitle;
        }
    }

    setPersonalizedContent(personalizedContent) {
        this.personalizedContent = personalizedContent;
        const personalizedContentElement = this.element.querySelector('.payment-card-personalized-content');
        if (personalizedContentElement) {
            personalizedContentElement.innerHTML = personalizedContent;
        }
    }

    // Method to mount the component to a container
    mount(container) {
        container.appendChild(this.element);
    }
}
